<script setup>
import { computed } from 'vue'
import { whatsappLink, trackConversion } from '@/lib/whatsapp'
import WhatsappIcon from '@/components/WhatsappIcon.vue'

const props = defineProps({
  // Account phone number, exactly as Rails hands it over.
  phone: { type: String, required: true },
  // Context written into the message: "el roller screen del living".
  subject: { type: String, default: '' },
  // Which part of the page the click came from, to measure what converts.
  source: { type: String, default: '' },
  label: { type: String, default: 'Cotizar por WhatsApp' },
  // glow: amber on dark. ink: brown on light. outline: no fill.
  variant: { type: String, default: 'glow' },
  size: { type: String, default: 'base' }
})

const href = computed(() => whatsappLink(props.phone, props.subject))

const variantClasses = {
  glow: 'bg-glow text-night hover:bg-[#f4a62a]',
  ink: 'bg-ink text-linen hover:bg-[#3a2b21]',
  outline: 'border border-current text-current hover:bg-current/10'
}

// Even the smallest button clears a 44px tap target: on mobile the small one
// is the header CTA, which is the primary action on the page.
const sizeClasses = {
  base: 'px-6 py-3.5 text-sm',
  large: 'px-8 py-4.5 text-base',
  small: 'px-5 py-3 text-sm'
}
</script>

<template>
  <a
    :href="href"
    target="_blank"
    rel="noopener"
    class="group inline-flex items-center gap-2.5 rounded-full font-semibold tracking-wide transition-colors duration-300"
    :class="[ variantClasses[variant], sizeClasses[size] ]"
    @click="trackConversion(source, subject)"
  >
    <WhatsappIcon class="h-[1.15em] w-[1.15em] shrink-0" />
    <span>{{ label }}</span>
  </a>
</template>
